import React, { useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Box, Typography, useMediaQuery, Card, CardContent, CardActions, Rating, Button, Collapse, useTheme, InputBase, IconButton, Divider } from "@mui/material"
import Header from './Header'
import FlexBetween from './FlexBetween'
import { UserAuth } from '../context/AuthContext'
import { useNavigate } from 'react-router-dom'
import { motion } from "framer-motion";
import Grid from '@mui/material/Unstable_Grid2';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';

import TokenContext from '../context/TokenContext'

import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { acompanamientosAulicos, resultadoGlobalCarrera, resultadoPracticaDocente } from '../Redux/desempeno'
import { COLUMNSACOMPANAMIENTOS, COLUMNSRESULTADOG, COLUMNSRESULTADOP } from '../columnas/columnasDesempeno'
import TablaDesempeno from './tablas/TablaDesempeno'
import CircularProgress from '@mui/material/CircularProgress';
import ModalFeedback from './modales/ModalFeedback'

const Desempeno = () => {
    const dispatch = useDispatch()
    const token = useContext(TokenContext)
    const { empleado } = UserAuth() //empleado contiene el usuarioPortalRh y empleadoid, esos dos valores son necesarios para las consultas a los fetch.
    const [valuePrimerTab, setValuePrimerTab] = React.useState('1'); //value del tablist

    const [resultadoP, setResultadoP] = React.useState([])
    const [loadingResultadoP, setLoadingResultadoP] = React.useState(false)
    const resultadoPracticaSelector = useSelector(store => store.desempeno.resultadoPractica)
    const getRESULTADOPselector = useSelector(store => store.desempeno.getResultadoP)

    const [resultadoG, setResultadoG] = React.useState([])
    const [loadingResultadoG, setLoadingResultadoG] = React.useState(false)
    const resultadoGlobalSelector = useSelector(store => store.desempeno.resultadoGlobal)
    const getRESULTADOGselector = useSelector(store => store.desempeno.getResultadoG)

    const [acompanamientos, setAcompanamientos] = React.useState([])
    const [loadingAcompanamientos, setLoadingAcompanamientos] = React.useState(false)
    const acompanamientosSelector = useSelector(store => store.desempeno.acompanamientos)
    const getACOMPANAMIENTOSselector = useSelector(store => store.desempeno.getAcompanamientos)

    const [openModal, setOpenModal] = React.useState(false);
    const [feedback, setFeedback] = React.useState('')

    React.useEffect(() => {
        if (token && empleado) {
            dispatch(resultadoPracticaDocente(token, empleado.usuarioPortalRh))
            dispatch(resultadoGlobalCarrera(token, empleado.usuarioPortalRh))
            dispatch(acompanamientosAulicos(token, empleado.usuarioPortalRh))
        }
    }, [token, empleado])

    React.useEffect(() => {
        if (resultadoPracticaSelector?.length > 0 && getRESULTADOPselector === true) {
            var array = []
            resultadoPracticaSelector.forEach(element => {
                var objeto = {
                    id: element.new_consolidadodeevaluacionesporperiodoid,
                    _new_periodo_value: element["_new_periodo_value@OData.Community.Display.V1.FormattedValue"],
                    new_creditostotales: element["new_creditostotales@OData.Community.Display.V1.FormattedValue"],
                    new_desempenio: element["new_desempenio@OData.Community.Display.V1.FormattedValue"],
                    new_name: element.new_name,
                    new_crditosactprodcontenido: element["new_crditosactprodcontenido@OData.Community.Display.V1.FormattedValue"],
                    new_creditosactaulicas: element["new_creditosactaulicas@OData.Community.Display.V1.FormattedValue"],
                    new_creditosactextension: element["new_creditosactextension@OData.Community.Display.V1.FormattedValue"],
                    new_creditosactgestion: element["new_creditosactgestion@OData.Community.Display.V1.FormattedValue"],
                    new_creditosactinvestigacion: element["new_creditosactinvestigacion@OData.Community.Display.V1.FormattedValue"]
                }
                array.push(objeto)
            });
            setResultadoP(array)
            setLoadingResultadoP(true)
        } else if (resultadoPracticaSelector?.length == 0 && getRESULTADOPselector === true) {
            setLoadingResultadoP(true)
        }
    }, [resultadoPracticaSelector])

    React.useEffect(() => {
        if (resultadoGlobalSelector?.length > 0 && getRESULTADOGselector === true) {
            var array = []
            resultadoGlobalSelector.forEach(element => {
                var objeto = {
                    id: element.new_consolidadodeevaluacionesporperiodoid,
                    _new_periodo_value: element["_new_periodo_value@OData.Community.Display.V1.FormattedValue"],
                    new_creditostotales: element["new_creditostotales@OData.Community.Display.V1.FormattedValue"],
                    new_desempenio: element["new_desempenio@OData.Community.Display.V1.FormattedValue"],
                    new_name: element.new_name,
                    new_crditosactprodcontenido: element["new_crditosactprodcontenido@OData.Community.Display.V1.FormattedValue"],
                    new_creditosactaulicas: element["new_creditosactaulicas@OData.Community.Display.V1.FormattedValue"],
                    new_creditosactextension: element["new_creditosactextension@OData.Community.Display.V1.FormattedValue"],
                    new_creditosactgestion: element["new_creditosactgestion@OData.Community.Display.V1.FormattedValue"],
                    new_creditosactinvestigacion: element["new_creditosactinvestigacion@OData.Community.Display.V1.FormattedValue"]
                }
                array.push(objeto)
            });
            setResultadoG(array)
            setLoadingResultadoG(true)
        } else if (resultadoGlobalSelector?.length == 0 && getRESULTADOGselector === true) {
            setLoadingResultadoG(true)
        }
    }, [resultadoGlobalSelector])

    React.useEffect(() => {
        if (acompanamientosSelector?.length > 0 && getACOMPANAMIENTOSselector === true) {
            var array = []
            acompanamientosSelector.forEach(element => {
                var objeto = {
                    id: element.new_observacionaulicaid,
                    _new_materia_value: element["_new_materia_value@OData.Community.Display.V1.FormattedValue"],
                    _new_observador_value: element["_new_observador_value@OData.Community.Display.V1.FormattedValue"],
                    new_fechadelaobservacin: element["new_fechadelaobservacin@OData.Community.Display.V1.FormattedValue"],
                    new_momentodelaclaseenqueseacompaa: element["new_momentodelaclaseenqueseacompaa@OData.Community.Display.V1.FormattedValue"],
                    new_didacticasde1ernivel: element["new_didacticasde1ernivel@OData.Community.Display.V1.FormattedValue"],
                    new_didctivasde2donivel: element["new_didctivasde2donivel@OData.Community.Display.V1.FormattedValue"],
                    new_informaciondiferencial: element.new_informaciondiferencial,
                    new_comentariosyfeedbackfinal: element.new_comentariosyfeedbackfinal
                }
                array.push(objeto)
            });
            setAcompanamientos(array)
            setLoadingAcompanamientos(true)
        } else if (acompanamientosSelector?.length == 0 && getACOMPANAMIENTOSselector === true) {
            setLoadingAcompanamientos(true)
        }
    }, [acompanamientosSelector])

    const handleChangePrimerTAB = (event, newValue) => {
        setValuePrimerTab(newValue);
    };

    //======|| handlers del modal FEEDBACK ||====== //
    const handleCloseModal = () => {
        setOpenModal(false)
        setFeedback('')
    };

    const handleOpenModalFeedback = (feedBack) => {
        setOpenModal(true);
        setFeedback(feedBack)
    };
    //======================================================= //

    return (
        <motion.div
            initial={{ opacity: 0, y: 100 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -100 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
        >
            <Box
                m="1.5rem 2.5rem"
            >
                <Header title={"Desempeño"} subtitle="" />
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12}>
                        <TabContext value={valuePrimerTab}>
                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'center',
                            }}>
                                <TabList
                                    aria-label="scrollable force tabs example"
                                    onChange={handleChangePrimerTAB} variant="scrollable"
                                    scrollButtons="auto"
                                    allowScrollButtonsMobile
                                    textColor="secondary"
                                    indicatorColor="secondary"
                                >
                                    <Tab label="Resultado Práctica Docente" value="1" sx={{ fontWeight: 'bold', fontSize: '16px' }} />
                                    <Tab label="Resultado Global De Carrera" value="2" sx={{ fontWeight: 'bold', fontSize: '16px' }} />
                                    <Tab label="Acompañamientos Aulicos" value="3" sx={{ fontWeight: 'bold', fontSize: '16px' }} />
                                </TabList>
                            </Box>
                            <TabPanel value="1">
                                <Box mt={2}>
                                    <Typography variant="h5" component="h2" gutterBottom>
                                        Los siguientes aspectos de evaluación conforman el resultado exclusivo de la práctica docente,
                                        considerando sus actividades áulicas y no áulicas en las distintas modalidades de cursado.
                                    </Typography>
                                    <Typography variant="body1" gutterBottom>
                                        Los ítems que componen esta valoración son:
                                    </Typography>
                                    <Typography variant="body1">
                                    <strong>Act. Áulicas</strong>: compuesta por la Encuesta docente (50 puntos) y la Coevaluación de pares (10 puntos)
                                    </Typography>
                                    <Typography variant="body1">
                                    <strong> Act. De Gestión</strong>: 10 puntos – Comprende el cumplimiento de obligaciones docentes
                                    </Typography>
                                </Box>
                                <Box mt={2}>
                                    {
                                        !loadingResultadoP ? (
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    width: '100%',
                                                    height: '100%',
                                                    py: 2
                                                }}>
                                                <CircularProgress color="secondary" />
                                            </Box>
                                        ) :
                                            resultadoP.length > 0 ? (
                                                <>
                                                    <TablaDesempeno columnas={COLUMNSRESULTADOP} lineas={resultadoP} />
                                                </>
                                            ) :
                                                <Alert severity="info">
                                                    <AlertTitle>Info</AlertTitle>
                                                    No existen registros de — <strong>Resultados de práctica docente</strong>.
                                                </Alert>
                                    }
                                </Box>
                            </TabPanel>

                            <TabPanel value="2">
                                <Box mt={2}>
                                    <Typography variant="h5" component="h2" gutterBottom>
                                        Los siguientes aspectos de evaluación conforman el resultado global de la carrera docente, considerando docencia, investigación, extensión y producción de contenidos. De este modo, es posible visualizar la integralidad del quehacer docente.
                                    </Typography>
                                    <Typography variant="body1" gutterBottom>
                                        Los ítems que componen esta valoración son:
                                    </Typography>
                                    <Typography variant="body1">
                                        Docencia: incorpora <strong>Act. Áulicas</strong>: compuesta por la Encuesta docente (50 puntos), la Coevaluación de pares (10 puntos) y <strong>Act. De Gestión</strong>: 10 puntos – Comprende el cumplimiento de obligaciones docentes
                                    </Typography>
                                    <Typography variant="body1">
                                    <strong>Act. De producción de contenidos</strong>: 10 puntos – Evaluación realizada por MECA
                                    </Typography>
                                    <Typography variant="body1">
                                    <strong>Act. De Extensión</strong>: 10 puntos – Evaluación realizada por Secretaría de Extensión, Vinculación e Impacto
                                    </Typography>
                                    <Typography variant="body1">
                                    <strong>Act. De Investigación</strong>: 10 puntos – Evaluación realizada por el Vicerrectorado de Innovación, Investigación y Postgrado
                                    </Typography>
                                </Box>
                                <Box mt={2}>
                                    {
                                        !loadingResultadoG ? (
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    width: '100%',
                                                    height: '100%',
                                                    py: 2
                                                }}>
                                                <CircularProgress color="secondary" />
                                            </Box>
                                        ) :
                                            resultadoG.length > 0 ? (
                                                <>
                                                    <TablaDesempeno columnas={COLUMNSRESULTADOG} lineas={resultadoG} />
                                                </>
                                            ) :
                                                <Alert severity="info">
                                                    <AlertTitle>Info</AlertTitle>
                                                    No existen registros de — <strong>Resultado global de carrera</strong>.
                                                </Alert>
                                    }
                                </Box>
                            </TabPanel>
                            <TabPanel value="3">
                                {
                                    !loadingAcompanamientos ? (
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                width: '100%',
                                                height: '100%',
                                                py: 2
                                            }}>
                                            <CircularProgress color="secondary" />
                                        </Box>
                                    ) :
                                        acompanamientos.length > 0 ? (
                                            <>
                                                <TablaDesempeno columnas={COLUMNSACOMPANAMIENTOS} lineas={acompanamientos} handleOpen={handleOpenModalFeedback} acciones={true} />
                                            </>
                                        ) :
                                            <Alert severity="info">
                                                <AlertTitle>Info</AlertTitle>
                                                No existen registros de — <strong>Acompañamientos aulicos</strong>.
                                            </Alert>
                                }
                            </TabPanel>
                        </TabContext>
                    </Grid>
                </Grid>
            </Box>
            <ModalFeedback open={openModal} handleClose={handleCloseModal} feedBack={feedback} />
        </motion.div>
    )
}

export default Desempeno